import CorrespondenciaAPI from '@/api/correspondencia'

export default {
  clear({ commit }) {
    commit('SET_CORRESPONDENCIAS', [])
  },
  clearEventos({ commit }) {
    commit('SET_EVENTOS', [])
  },
  fetchAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      CorrespondenciaAPI.list(params.pagina)
        .then(response => {
          commit('ADD_CORRESPONDENCIAS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchOne({ commit }, params) {
    return new Promise((resolve, reject) => {
      CorrespondenciaAPI.obter(params.id)
        .then(response => {
          commit('ADD_CORRESPONDENCIAS', [response.data])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchEventos({ commit }, params) {
    return new Promise((resolve, reject) => {
      CorrespondenciaAPI.listEventos(params.id)
        .then(response => {
          commit('ADD_EVENTOS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  confirmar({ commit }, params) {
    return new Promise((resolve, reject) => {
      CorrespondenciaAPI.confirmar(params)
        .then(response => {
          commit('SET_EVENTOS', [])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  devolver({ commit }, params) {
    return new Promise((resolve, reject) => {
      CorrespondenciaAPI.devolver(params)
        .then(response => {
          commit('SET_EVENTOS', [])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
